import * as React from 'react';
import { CheckboxButton } from '@cian/ui-kit';

import { saleTypeDescriptor } from '../../constants/descriptors';
import { isDescriptorActive } from '../../utils/filters';
import { connectToDescriptors, IDescriptorProps } from '../сonnectToDescriptors';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getOffersCount } from '../../actions/offersData';

export interface ISaleTypeTypeProps extends IDescriptorProps<string> {
  getOffersCount(): void;
}

class SaleTypeComponent extends React.Component<ISaleTypeTypeProps> {
  public shouldComponentUpdate(nextProps: ISaleTypeTypeProps) {
    const { descriptors, jsonQuery } = this.props;
    const activeDescriptor = descriptors.find(descriptor => isDescriptorActive(descriptor)(jsonQuery));
    const nextActiveDescriptor = nextProps.descriptors.find(descriptor =>
      isDescriptorActive(descriptor)(nextProps.jsonQuery),
    );
    /* istanbul ignore next */
    const value = activeDescriptor ? activeDescriptor.state : undefined;
    /* istanbul ignore next */
    const nextValue = nextActiveDescriptor ? nextActiveDescriptor.state : undefined;

    return nextValue !== value;
  }

  public render() {
    const { jsonQuery, descriptors } = this.props;
    const activeDescriptor = descriptors.find(descriptor => isDescriptorActive(descriptor)(jsonQuery));
    const value = activeDescriptor ? activeDescriptor.state : undefined;

    return <CheckboxButton label="214-ФЗ" name="saleType" onChange={this.handleChange} checked={value === 'fz_214'} />;
  }

  private handleChange = () => {
    this.props.actionCreator(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.props.descriptors.find(d => {
        return d.state === 'fz_214';
        // убрали правило из конвенции и из tslint-config(https://cianru.atlassian.net/browse/CD-33534),
        // но забыли про test-utils, по этому пока  пишем с исключениями
      })!,
    )();
    this.props.getOffersCount();
  };
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
  };
}

export const SaleType = connectToDescriptors(saleTypeDescriptor, mapDispatchToProps)(SaleTypeComponent);
